'use strict';

// export this package's api
module.exports = require('./Upload');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.2.0@rc-upload/lib/index.js
 ** module id = 447
 ** module chunks = 0
 **/